const consultation = {
  // Hero Section
  heroTitle: 'Expert Property Consultation',
  heroSubtitle: 'Schedule your online consultation with certified property experts. Connect with us remotely for professional guidance.',
  certifiedExperts: 'Certified Experts',
  onlineBooking: 'Online Booking',
  satisfaction: '100% Satisfaction',

  // Package Section
  packageTitle: 'Choose Your Consultation Package',
  packageSubtitle: 'Select the consultation package that best fits your property needs and budget',
  mostPopular: 'Most Popular',

  // Packages
  packages: {
    basic: {
      name: 'Basic Property Consultation',
      duration: '60 minutes',
      description: 'Perfect for first-time buyers or those looking for general property advice',
      feature1: 'Online video consultation',
      feature2: 'Jeddah market overview and trends',
      feature3: 'Property valuation guidance',
      feature4: 'Basic financing options',
      feature5: 'Follow-up email summary',
    },
    premium: {
      name: 'Premium Investment Analysis',
      duration: '90 minutes',
      description: 'Comprehensive online consultation for serious investors and property professionals',
      feature1: 'Online video consultation',
      feature2: 'Detailed Jeddah market analysis',
      feature3: 'Investment ROI calculations',
      feature4: 'Risk assessment',
      feature5: 'Custom property recommendations',
      feature6: 'Written investment report',
      feature7: '30-day online follow-up support',
    },
    luxury: {
      name: 'Luxury Property Consultation',
      duration: '2 hours',
      description: 'Exclusive online consultation for high-end property transactions',
      feature1: 'Premium online video consultation',
      feature2: 'Luxury Jeddah market insights',
      feature3: 'Exclusive property access',
      feature4: 'Virtual property tours',
      feature5: 'Negotiation strategies',
      feature6: 'Legal and tax implications',
      feature7: 'Ongoing online relationship management',
    },
  },

  // Features
  easyScheduling: 'Easy Online Scheduling',
  bookConsultation: 'Book Consultation',
  instantBooking: 'Instant Booking',
  instantBookingDesc: 'Book your consultation instantly with real-time availability',
  autoReminders: 'Auto Reminders',
  autoRemindersDesc: 'Receive email and SMS reminders before your appointment',
  videoMeetings: 'Video Meetings',
  videoMeetingsDesc: 'Join consultations via video call or phone',
  calendarSync: 'Calendar Sync',
  calendarSyncDesc: 'Automatically sync with your Google, Outlook, or Apple calendar',

  // Form Section
  formTitle: 'Schedule Your Consultation',
  fullName: 'Full Name',
  fullNameRequired: 'Full Name *',
  email: 'Email Address',
  emailRequired: 'Email Address *',
  phone: 'Phone Number',
  phoneRequired: 'Phone Number *',
  propertyType: 'Property Type',
  propertyTypeRequired: 'Property Type *',
  budgetRange: 'Budget Range',
  budgetRangeRequired: 'Budget Range *',
  message: 'Message (Optional)',
  preferredTimeSlot: 'Preferred Time Slot',
  consultationPackage: 'Consultation Package',

  // Placeholders
  enterFullName: 'Enter your full name',
  enterEmail: 'your.email@example.com',
  enterPhone: '+966 XX XXX XXXX',
  selectPropertyType: 'Select Property Type',
  selectBudgetRange: 'Select Budget Range',
  enterMessage: 'Tell us about your property needs...',

  // Property Types
  house: 'House',
  apartment: 'Apartment',
  condo: 'Condo',
  townhouse: 'Townhouse',
  commercial: 'Commercial',
  investmentProperty: 'Investment Property',

  // Budget Ranges
  under200k: 'Under $200k',
  range200to500k: '$200k - $500k',
  range500kto1m: '$500k - $1M',
  range1to2m: '$1M - $2M',
  over2m: 'Over $2M',

  // Buttons
  backToPackages: 'Back to Packages',
  chooseTimeSlot: 'Choose Time Slot',
  openCalendar: 'Open Calendar & Schedule',

  // Info Box
  quickSetup: 'Quick Setup Required',
  quickSetupDesc: 'Fill out this simple form to get started with your consultation. One of our property experts will reach out to you shortly.',

  // Alert Messages
  fillAllFields: 'Please fill in all required fields before scheduling.',
  paymentFailed: 'Failed to process consultation payment. Please try again.',
  scheduledSuccess: 'Consultation scheduled successfully! You will receive a confirmation email shortly.',

  // Success Page
  successTitle: 'Consultation Scheduled!',
  successMessage: 'Your consultation has been successfully scheduled.',
  successDetails: 'We\'ve sent a confirmation email with all the details. Our expert will contact you shortly to confirm your appointment.',
  backToHome: 'Back to Home',
  viewConsultations: 'View My Consultations',
};

export default consultation;
